import type { PriorityPlaylist } from '@backrs_ui/common-ui';

import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

export const useAgentContext = (playlists: PriorityPlaylist[]) => {
  useRegisterAgentContext({
    kind: 'section',
    title: 'Suggested Playbooks',
    description: 'System-recommended playbooks the user can adopt',
  });

  useRegisterAgentContext({
    kind: 'list',
    description: 'Suggested playbooks available to the user',
    data: { suggestedPlaylists: playlists },
  });
};
